import i18n from "@/language";
import {useSwalAlert} from "@/hook/useSwalAlert";
import http from "@/api";
import {usePermission} from "@/hook/usePermission";

/**
 * API（僅本 hook 使用 → 內聯實作，不另立 api/module）
 * 回總會 GET /api/admin/church/head、模擬登入 POST /api/admin/church/simulation、修復 POST /api/admin/church/repair
 * head 與 simulation 帶 builtIn.done=false（不顯示內建成功提示，改由 completion 自行接手切換身分）
 */
const churchUri = `/api/admin/church`;
const silentDone = (completion) => ({
    opts: {builtIn: {done: false}, completion: {done: (e) => completion(e)}}
});
const apiHead = (completion) =>
    http.get(`${churchUri}/head`, {}, silentDone(completion));
const apiSimulation = (params, completion) =>
    http.post(`${churchUri}/simulation`, params, silentDone(completion));
const apiRepair = (params, completion) =>
    http.post(`${churchUri}/repair`, params, {
        opts: {completion: {done: (e) => completion(e)}}
    });

/**
 * 模擬登入
 */
export const useSimulation = () => {

    //導入i18n
    const {
        //@ts-ignore
        t
    } = i18n.global

    const {
        showHandler,
        showTwoFactory
    } = useSwalAlert()

    const {
        updateLogin
    } = usePermission()

    /**
     * 返回
     */
    const onBack = () => showHandler({
        subject: t(`handler.session.head.subject`),
        text: t(`handler.session.head.text`),
        completion: {
            success: async () => await apiHead((e) => {

                //如果返回異常, 不往下執行
                if (!e.result) return false

                //新的權杖已由後端寫進 cookie
                updateLogin(true)

            })
        }
    })

    /**
     * 提交
     */
    const onSubmit = (
        params,
        appContext
    ) => showTwoFactory({
        subject: t(`handler.session.simulation.subject`),
        text: t(`handler.session.simulation.text`),
        description: t(`handler.session.repair.description`),
        completion: {
            success: async () => await apiSimulation(
                params,
                (e) => {

                    //如果返回異常, 不往下執行
                    if (!e.result) return false

                    //新的權杖已由後端寫進 cookie
                    updateLogin(true)

                }
            )
        }
    }, appContext)

    /**
     * 重建模擬
     */
    const onRepair = (
        params,
        appContext
    ) => showTwoFactory({
        subject: t(`handler.session.repair.subject`),
        text: t(`handler.session.repair.text`),
        description: t(`handler.session.repair.description`),
        completion: {
            success: async () => await apiRepair(
                params,
                () => {}
            )
        }
    }, appContext)

    return {
        onBack,
        onSubmit,
        onRepair
    }

}
